import React from "react";
import { Text, Box } from "../../theme";
import { map } from "lodash";
const content = {
  address: "900 S. Gay Street, Knoxville, Tennessee 37902",
  phone: "Phone: (865) 546-0500",
  fax: "Fax: (865) 525-5293",
  copyright: "All content Copyright 2018. All rights reserved."
};
export const Footer = props => {
  return (
    <Box
      width={1}
      bg="primary"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="noWrap"
    >
      {map(content, c => (
        <Box>
          <Text
            p={3}
            key={c}
            textAlign="center"
            color="white"
            display={["none", null, "block"]}
            fontSize={[0]}
          >
            {c}
          </Text>
        </Box>
      ))}
      <Text
        color="white"
        display={["block", null, "none"]}
        fontSize={[0]}
        py={[3]}
      >
        {content.copyright}
      </Text>
    </Box>
  );
};
